import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Landing() {
  const [show, setShow] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        "https://sheetmanagement.sobalex.com/backend/public/index.php?endpoint=login",
        { username, password }
      );

      if (response.data.status === "success") {
        localStorage.setItem("userRole", response.data.role);
        handleClose();

        // Role-based navigation
        switch (response.data.role) {
          case "admin":
            navigate("/admin-dashboard");
            break;
          case "1Party":
            navigate("/1party-dashboard");
            break;
          case "2Party":
            navigate("/2party-dashboard");
            break;
          case "3Party":
            navigate("/3party-dashboard");
            break;
          case "4Party":
            navigate("/4party-dashboard");
            break;
          case "5Party":
            navigate("/5party-dashboard");
            break;
          case "PhotoOffice":
            navigate("/photo-office-dashboard");
            break;
          default:
            setError("Unauthorized access");
        }
      } else {
        setError("Invalid Credentials");
      }
    } catch (error) {
      console.error("Login error", error);
      setError("Server error, try again later");
    }
  };

  return (
    <div className="container text-center mt-5">
      <h1>Welcome to Sheet Management System</h1>
      <p>Your secure database management solution.</p>
      <div className="mt-4">
        <Button variant="dark" className="m-2" onClick={handleShow}>Admin Dashboard</Button>
        <Button variant="primary" className="m-2" onClick={handleShow}>1Party</Button>
        <Button variant="secondary" className="m-2" onClick={handleShow}>2Party</Button>
        <Button variant="success" className="m-2" onClick={handleShow}>3Party</Button>
        <Button variant="warning" className="m-2" onClick={handleShow}>4Party</Button>
        <Button variant="danger" className="m-2" onClick={handleShow}>5Party</Button>
        <Button variant="info" className="m-2" onClick={handleShow}>Photo Office</Button>
      </div>

      {/* Modal for Login Form */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>User Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <p className="text-danger">{error}</p>}
          <Form>
            <Form.Group controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formPassword" className="mt-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={handleLogin}>Login</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Landing;
